'use client';

import { usePathname, useSearchParams } from 'next/navigation';

import Links from '~/lib/helpers/link-helper';

import Pill from '../pill';

import styles from '~/styles/components/product/product-tags.module.scss';
import { mapQueryBy, mapSortBy } from 'sdk';
import { Box } from '../layout/box';
import Text from '../typography/text';
import AccordionWrapper from '../accordion/wrapper';
import AccordionHeaderWrapper from '../accordion/header-wrapper';
import AccordionContentWrapper from '../accordion/content-wrapper';

export default function ProductTags({ tags, title }: { tags: string[]; title: string }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  function formattedTag(tag) {
    if (!tag) return;
    if (tag.startsWith('#')) {
      return tag;
    }

    return `#${tag}`;
  }

  if (!tags || tags.length < 1) return null;

  return (
    <AccordionWrapper>
      <AccordionHeaderWrapper>
        <Box>
          <Text size='large' font='bold'>
            Tags
          </Text>
        </Box>
      </AccordionHeaderWrapper>
      <AccordionContentWrapper>
        <div className={styles.tags}>
          <div className={styles['tags-container']}>
            {tags?.map((tag, i) => {
              return (
                <span key={`${tag}-${i}`} className={styles['tags-pill']}>
                  <Pill
                    text={formattedTag(tag)}
                    link={{
                      href: Links.searchWithQueryAppRouter({
                        pathname,
                        searchParams,
                        options: {
                          index: 'books',
                          params: {
                            q: '*',
                            sort_by: mapSortBy('books'),
                            query_by: mapQueryBy('books'),
                            filter_by: `hashtags:${formattedTag(tag)}`,
                          },
                          options: {},
                        },
                        path: '/search',
                      }).url,
                    }}
                  />
                </span>
              );
            })}
          </div>
        </div>
      </AccordionContentWrapper>
    </AccordionWrapper>
  );
}
